export const commons = {
  academyRegistrationYear: {
    label: 'Registration Year'
  },
  account: {
    label: 'Account',
    plural: 'Accounts',
    manage: 'Account Management'
  },
  address: {
    copy: 'Copy Address',
    label: 'Address'
  },
  addressLine1: {
    label: 'Address Line 1'
  },
  addressLine2: {
    label: 'Address Line 2'
  },
  age: {
    label: 'Age'
  },
  approval: {
    byAdmin: {
      label: 'Approval by admin'
    },
    byAthlete: {
      label: 'Approval by athlete'
    },
    desc: 'Field subject to approval',
    label: 'Approval'
  },
  approvalByAdmin: {
    label: 'Approval by admin'
  },
  approvalByAthlete: {
    label: 'Approval by Athlete'
  },
  approvalRequired: {
    label: 'Approval required',
    help: 'Approval is required to complete the request'
  },
  approve: {
    label: 'Approve'
  },
  approvedAt: 'Approved at',
  assistantProfessor: {
    label: 'Additional Professor',
    plural: 'Additional Professors'
  },
  association: {
    label: 'Association'
  },
  authorizationDate: {
    abbr: 'Auth. Dt.',
    label: 'Authorization Date'
  },
  back: {
    label: 'Back'
  },
  bgCheck: {
    label: 'Background Check'
  },
  businessName: {
    label: 'Business Name'
  },
  cancel: {
    label: 'Cancel'
  },
  cancelationDate: {
    label: 'Cancelation Date'
  },
  csvExport: {
    jobSucceeded:
      'CSV Export succeeded. If the download did not start automatically, click {link} to download.',
    jobFailed: 'CSV Export failed. Please try again later or contact tech support.'
  },
  remove: {
    label: 'Remove'
  },
  removedNotification: {
    guardianship: 'Guardianships successfully canceled',
    membership: 'Membership successfully canceled',
    errorGuardianship: 'An error occurred while trying to cancel. Please try again later.'
  },
  capture: {
    label: 'Capture'
  },
  captureDate: {
    abbr: 'Cap. Dt.',
    label: 'Capture Date'
  },
  changeType: 'Change Type',
  changeDate: 'Change Date',
  chargeBackDate: {
    label: 'ChargeBack Date'
  },
  city: {
    label: 'City'
  },
  color: {
    label: 'Color'
  },
  confirm: {
    label: 'Confirm'
  },
  confirmationDate: {
    label: 'Confirmation Dt.'
  },
  continue: {
    label: 'Continue'
  },
  country: {
    label: 'Country',
    placeholder: 'Select the country'
  },
  creditCard: {
    authorizationCode: 'Security Code',
    expirationDate: 'Expiration Dt.',
    label: 'Credit Card',
    number: 'Number'
  },
  createdAt: {
    label: 'Created at'
  },
  close: {
    label: 'Close'
  },
  date: {
    label: 'Date'
  },
  dateEnd: {
    label: 'Dt. End'
  },
  dateOfBirth: {
    label: 'Date of Birth'
  },
  dateScheduled: {
    label: 'Dt. Sched.'
  },
  dateStart: {
    label: 'Dt. Start'
  },
  delete: {
    label: 'Delete'
  },
  description: {
    label: 'Description'
  },
  details: {
    label: 'Details'
  },
  diff: {
    label: 'Diff.'
  },
  discount: {
    label: 'Discount'
  },
  document: {
    beltRecords: {
      label: 'Belt Records'
    },
    beltHistory: {
      label: 'Belt History'
    },
    certificationForm: {
      label: 'Certification Form'
    },
    firstAid: {
      label: 'First Aid'
    },
    identification: {
      label: 'Identification Document',
      types: {
        idCard: 'Government Photo ID',
        passport: 'Passport',
        driverLicense: "Driver's License",
        birthCertificate: 'Birth Certificate',
        livretFamille: 'Livret de Famille',
        canadianBirthCertificate: 'Birth Certificate with Parental Information',
        custodyCertificate: 'Custody Certificate',
        guardianshipCertificate: 'Guardianship Certificate',
        others: 'Others'
      }
    },
    identificationLegalParent: {
      label: 'Identification Legal Parent'
    },
    guardianIdentification: {
      label: 'Guardian Identification',
      types: {
        idCard: 'Government Photo ID',
        passport: 'Passport',
        driverLicense: 'Driver License',
        others: 'Others'
      }
    },
    underageAthleteIdentification: {
      label: 'Underage Identification',
      types: {
        idCard: 'Government Photo ID',
        passport: 'Passport',
        driverLicense: 'Driver License',
        birthCertificate: 'Birth Certificate',
        livretFamille: 'Livret de Famille',
        canadianBirthCertificate: 'Birth Certificate with Parental Information'
      }
    },
    legalBondIdentification: {
      label: 'Legal Bond Identification',
      types: {
        custodyCertificate: 'Custody Certificate',
        guardianshipCertificate: 'Guardianship Certificate'
      }
    },
    medicalWaiver: {
      label: 'Medical Waiver'
    },
    proofOfAddress: {
      label: 'Proof of Address'
    },
    physicalForm: {
      label: 'Physical Membership Form',
      physicalRegistrationForm: {
        label: 'Registration Form'
      },
      physicalBeltHistory: {
        label: 'Belt History'
      },
      types: {
        physicalRegistrationForm: 'Physical Registration Form',
        physicalBeltHistory: 'Physical Belt History'
      }
    },
    other: {
      label: 'Other'
    },
    photo: {
      label: 'Photo'
    },
    portugalMedicalWaiver: {
      label: 'Portugal Medical Waiver'
    },
    rulesSeminar: {
      label: 'Rules Seminar'
    },
    includeApprovedDocument: {
      label: 'Add new document'
    },
    plural: 'Documents'
  },
  edit: {
    by: 'Edited by',
    label: 'Edit'
  },
  editRegistrations: {
    label: 'Edit Registrations'
  },
  email: {
    label: 'Email',
    plural: 'Emails'
  },
  execute: {
    label: 'Execute'
  },
  expirationDate: {
    abbr: 'Exp. Dt.'
  },
  field: {
    new: {
      label: 'New Field'
    }
  },
  filterBy: {
    label: 'Filter by'
  },
  filteredBy: {
    label: 'Filtered by'
  },
  finish: {
    label: 'Finish'
  },
  form: {
    label: 'Form'
  },
  free: {
    label: 'Free',
    set: {
      confirmation: 'Are you sure want to set this payment as free?',
      label: 'Set as free'
    },
    unset: {
      confirmation: 'Are you sure want to unset this payment as free?',
      label: 'Unset as free'
    }
  },
  gender: {
    label: 'Gender',
    male: 'Male',
    female: 'Female'
  },
  headProfessor: {
    abbr: 'Head',
    label: 'Head Professor'
  },
  history: {
    label: 'History'
  },
  home: {
    label: 'Home'
  },
  id: {
    label: 'N.'
  },
  info: {
    label: 'Information'
  },
  items: {
    label: 'Items'
  },
  keyword: {
    label: 'Keyword'
  },
  link: {
    plural: 'Links'
  },
  login: {
    as: 'Logged as'
  },
  logout: {
    label: 'Logout'
  },
  mailAddress: {
    label: 'Mail Address'
  },
  name: {
    first: 'First Name',
    label: 'Name',
    last: 'Last Name',
    full: 'Full Name'
  },
  nationality: {
    label: 'Nationality',
    placeholder: 'Select your nationality'
  },
  new: {
    label: 'New'
  },
  next: {
    label: 'Next',
    plural: 'Next'
  },
  no: {
    label: 'No'
  },
  notHere: {
    text: 'No results found'
  },
  obs: {
    label: 'Note',
    visible: {
      label: 'Show note to athlete'
    }
  },
  open: {
    label: 'All Tournaments'
  },
  or: {
    label: 'Or'
  },
  paid: {
    set: {
      label: 'Set as Paid'
    }
  },
  paymentDate: {
    label: 'Dt. Payment'
  },
  password: {
    label: 'Password'
  },
  passwordConfirmation: {
    label: 'Password Confirmation'
  },
  payPal: {
    label: 'PayPal',
    id: {
      label: 'PayPal ID'
    },
    authorization: {
      label: 'Authorization'
    },
    order: {
      label: 'Order'
    },
    payer: {
      label: 'Payer'
    },
    error: {
      label: 'Error trying to fetch Paypal payment details.'
    },
    details: {
      label: 'More details'
    }
  },
  phoneNumber: {
    label: 'Phone'
  },
  physicalCards: {
    printingBatchJobCreated: 'The printing file is being generated.',
    printingBatchJobFailed: 'Error while generating printing batch.',
    printingBatchJobSuccess:
      'Batch file generated successfully. If download did not start automatically, check if your pop-up blocker is enabled.'
  },
  price: {
    label: 'Price'
  },
  print: {
    label: 'Print',
    history: {
      label: 'Print History'
    },
    confirmation: 'Are you sure?'
  },
  professor: {
    label: 'Professor',
    plural: 'Professors'
  },
  professorName: {
    label: 'Professor Name'
  },
  profile: {
    label: 'My Membership'
  },
  reason: {
    label: 'Reason'
  },
  record: {
    abbrMessage: 'Found {0} records.',
    message: 'Found {0} records. Showing record {1} to {2}.'
  },
  refresh: {
    label: 'Refresh'
  },
  registration: {
    label: 'Registration'
  },
  reject: {
    label: 'Reject'
  },
  renew: {
    label: 'Renew'
  },
  renewal: {
    label: 'Renewal'
  },
  responsible: {
    label: 'Responsible'
  },
  request: {
    label: 'Request'
  },
  requestDate: {
    abbr: 'Req. Dt.'
  },
  requester: {
    label: 'Requester'
  },
  resolve: {
    label: 'Resolve'
  },
  safeSport: {
    label: 'SafeSport'
  },
  save: {
    label: 'Save'
  },
  search: {
    byName: 'Search by name',
    label: 'Search',
    clear: 'Clear'
  },
  security: {
    label: 'Security'
  },
  send: {
    label: 'Send'
  },
  showInCertificate: {
    abbr: 'Cert.',
    label: 'Show in Certificate'
  },
  site: {
    label: 'Site'
  },
  softService: {
    label: 'SoftService'
  },
  solicitation: {
    plural: 'Requests',
    memberships: 'Memberships',
    prints: 'Membership Card Prints',
    guardianships: 'Guardianships'
  },
  state: {
    label: 'State'
  },
  status: {
    label: 'Status'
  },
  streetNumber: {
    label: 'Street Number'
  },
  subject: {
    label: 'Subject'
  },
  summary: {
    label: 'Summary'
  },
  subscribe: {
    label: 'Subscriptions'
  },
  table: {
    selectAllPages: 'Select all registers fo all pages'
  },
  template: {
    label: 'Template'
  },
  title: {
    label: 'Title'
  },
  total: {
    label: 'Total'
  },
  transfer: {
    label: 'Transfer'
  },
  type: {
    label: 'Type'
  },
  updatedAt: {
    label: 'Updated at'
  },
  yes: {
    label: 'Yes'
  },
  value: {
    label: 'Value'
  },
  view: {
    label: 'View',
    all: 'View All'
  },
  zipCode: {
    label: 'Zip Code'
  },
  listOfRequestIsEmpty: 'No orders yet.',
  events: {
    upcoming: 'Upcoming',
    empty: 'There are no events at this time.',
    upcomingEmpty: 'There are no upcoming events at this time.',
    correctionsEmpty: 'There are no championship for corrections at this time.',
    invitationsEmpty: 'There are no championship invitations at this time.',
    registered: 'Subscribed',
    registeredEmpty: 'You currently have no subscription.',
    registerNow: 'Register Now',
    editRegistration: 'Edit Subscription',
    viewRegistration: 'View Subscription',
    paymentPendent: 'Pay subscription',
    documentationPendent: 'In Analisys',
    manage: 'Manage'
  },
  moreDetails: {
    label: 'More Details'
  },
  place: {
    label: 'Place'
  },
  openClass: {
    label: 'Open Class'
  },
  showAll: {
    label: 'Show all'
  },
  fromDate: {
    label: 'From {0}'
  },
  toDate: {
    label: 'To {0}'
  },
  invoiceNumber: {
    label: 'Invoice N.'
  },
  transactionNumber: {
    label: 'Transaction N.'
  },
  fullScreen: {
    label: 'Fullscreen'
  },
  createdBy: {
    label: 'Created By'
  },
  dashboard: {
    label: 'Dashboard'
  },
  validThrough: 'Valid Through'
}
export const domain = {
  idNumber: {
    label: 'Id Number'
  },
  academy: {
    all: {
      label: 'All Academies'
    },
    create: 'New Academy',
    delete: {
      label: 'Delete Academy',
      text: 'Do you really want delete this academy?'
    },
    id: {
      label: 'Academy N.'
    },
    info: {
      extra: 'Additional Info',
      label: 'Academy Info'
    },
    label: 'Academy',
    homonyms: {
      label: 'Homonyms',
      clearSearch: 'Clear Search'
    },
    plural: 'Academies'
  },
  academyProfessor: {
    create: {
      label: 'New Professor'
    },
    delete: {
      confirm: 'Professor deleted successfully!',
      label: 'Delete Professor',
      text: 'Are you sure you want to <b>delete</b> your account? This action cannot be undone.'
    },
    label: 'Professor',
    headProfessor: {
      warning:
        'Only can have one head professor per academy.\n' +
        'Currently the head professor is {professorName}.\n' +
        'If you continue, he/she will be unmarked as head.'
    },
    championshipRegistrationRevision: {
      abbr: 'Champ. Reg. Edit.',
      label: 'Can edit student championship registration'
    },
    showInCertificate: {
      warning:
        'Limit of teachers printed on the certificates has been exceeded. You need to disable a professor to add new ones to the certificates'
    },
    periodProfessor: {
      label: 'Period as a professor'
    },
    plural: 'Professors'
  },
  academyRegistration: {
    abbr: 'Registration',
    academyName: {
      help: 'Enter the name of the academy. If it is renewal, you can rename it.'
    },
    assistantProfessor: {
      approval:
        'Professor <strong>{professorName}</strong> wants to have you listed as one of the professor for the academy <strong>{academyName}</strong>',
      help: 'Inform the professors who are part of the academy.'
    },
    association: {
      approval:
        'Academy Request to be registered under <strong>{association}</strong> Association.',
      help: 'Fill in only if your academy is part of an association.'
    },
    documentationRequiredErrorNotification: `We have verified that you do not have Background Check
      and Safe Sport approved yet. Make your application to them and once both are approved you will
      be able to continue your application for Academy Registration.`,
    backgroundCheck: {
      label: 'Background Check',
      backgroundCheckConfirmed: 'I have applied for a background check in the last 12 months.',
      explanation: `
          <p>
            All professors who will be listed for U.S. academies will need to have a clean background check on file with NCSI within the last 12 months.
          </p>

          <p>
            Please refer to the <a href="https://ibjjf.com/background-check/" target="_blank">Background Check</a> for more information.
          </p>
        `
    },
    safeSport: {
      label: 'SafeSport',
      safeSportConfirmed: 'I did the SafeSport course.',
      explanation: `
          <p>
            All professors who will be listed for U.S. academies will need to complete the SafeSport Training Course within the last 12 months.
          </p>

          <p>
            Please refer to the <a href="https://ibjjf.com/safe-sport" target="_blank">SafeSport</a> for more information.
          </p>
        `
    },
    cancel: {
      label: 'Cancel Academy Registration Request',
      text: 'Do you really want cancel this request?'
    },
    create: {
      cancelAndCreate: 'Create new request',
      label: 'New Registration',
      openExistent: 'Go to current request',
      warning:
        'This academy has an open registration request. If you continue this request will be canceled and another will be created.'
    },
    delete: {
      label: 'Delete Academy Registration',
      text: 'Do you really want delete this registration?'
    },
    documentIpdj: {
      label: 'Professional Title of Sports Trainer',
      small: 'Issued by the Portuguese Institute of Sport and Youth.',
      info: `- Coach Course Information <a href="https://www.fpjjb.com/formacao-sub" targe="_blank">https://www.fpjjb.com/formacao-sub</a>`
    },
    form: {
      skipAdditionalProfessors: "I don't want to register Additional Professors",
      skipAssociation: "I don't want to register Association",
      documentIpdj: {
        dropInstructions: `
          Drop or click to upload your<br />
          <strong>Brazilian jiu-jitsu trainer course certificate grade I</strong>.
        `
      },
      backgroundCheck: {
        backgroundCheckConfirmed: 'I have applied for a background check in the last 12 months.',
        notUSAResident: "I'm not USA resident",
        explanation: `
            <p>
              All professors who will be listed for U.S. academies will need to have a clean background check on file with NCSI within the last 12 months.
            </p>

            <p>
              Please refer to the
              <a
                href="https://ibjjf.com/background-check/"
                target="_blank"
                >Background Check</a
              >
              for more information.
            </p>
          `
      },
      safeSport: {
        safeSportConfirmed: 'I did the SafeSport course.',
        safeSportNotConfirmed: 'SafeSport not confirmed.',
        explanation: `
            <p>
              All professors who will be listed for U.S. academies will need to complete the SafeSport Training Course within the last 12 months.
            </p>

            <p>
              Please refer to the
              <a
                href="https://ibjjf.com/safe-sport"
                target="_blank"
                >SafeSport</a
              >
              for more information.
            </p>
          `
      }
    },
    historic: {
      label: 'Historic',
      title: 'Academy Registrations Historic'
    },
    id: {
      label: 'Academy Registration N.'
    },
    label: 'Academy Registration',
    notHere: {
      text: 'Nothing here.'
    },
    history: {
      label: 'Request History'
    },
    my: {
      plural: 'My Academies'
    },
    plural: 'Academy Registrations',
    summary: {
      label: 'Request Summary'
    },
    warnings: {
      rejected: 'Some fields have been rejected and need correction'
    }
  },
  academyTeam: {
    all: 'All Teams',
    create: {
      label: 'New Team'
    },
    delete: {
      confirm: 'Team deleted successfully!',
      label: 'Delete Team',
      text: 'Are you sure you want to <b>delete</b> your team? This action cannot be undone.'
    },
    label: 'Team',
    main: {
      label: 'Main Team'
    },
    plural: 'Teams',
    original: {
      back: 'Return to original team'
    },
    transfer: {
      all: 'Move all athletes to a new team',
      from: 'Transfer from',
      label: 'Team Transfer',
      help: 'Select new team.',
      none: 'No athlete will be transferred',
      to: 'To',
      warning: 'Attention! The athletes below will be transferred to the new team.'
    }
  },
  accessControl: {
    label: 'Access Control',
    user: {
      create: {
        label: 'New Admin User'
      }
    },
    userGroup: {
      create: {
        label: 'New User Group'
      },
      delete: {
        disabled: 'This User Group is being used by the system.',
        label: 'Delete User Group',
        text: 'Are you sure you want to delete this user group?'
      },
      label: 'Permission Group',
      plural: 'Permission Groups'
    },
    permission: {
      label: 'Permission',
      plural: 'Permissions',
      legacyPlural: 'Permissions (Legacy .NET)'
    }
  },
  ageDivision: {
    label: 'Age Division',
    Adult: 'Adult',
    Junior: 'Junior',
    Junior1: 'Junior 1',
    Junior2: 'Junior 2',
    Junior3: 'Junior 3',
    Juvenile: 'Juvenile',
    Juvenile1: 'Juvenile 1',
    Juvenile2: 'Juvenile 2',
    Master1: 'Master 1',
    Master2: 'Master 2',
    Master3: 'Master 3',
    Master4: 'Master 4',
    Master5: 'Master 5',
    Master6: 'Master 6',
    Master7: 'Master 7',
    MightyMite: 'MightyMite',
    MightyMite1: 'MightyMite 1',
    MightyMite2: 'MightyMite 2',
    MightyMite3: 'MightyMite 3',
    PeeWee: 'PeeWee',
    PeeWee1: 'PeeWee 1',
    PeeWee2: 'PeeWee 2',
    PeeWee3: 'PeeWee 3',
    Teen: 'Teen',
    Teen1: 'Teen 1',
    Teen2: 'Teen 2',
    Teen3: 'Teen 3'
  },
  association: {
    create: {
      label: 'New Association'
    },
    delete: {
      confirm: 'Academy deleted successfully!',
      label: 'Remove Academy',
      text:
        'Are you sure you want to <b>remove</b> your academy ({0}) from current association ({1})? This action cannot be undone.'
    },
    edit: {
      label: 'Edit Association'
    },
    messages: {
      addAcademy: 'Academy added successfully!',
      removeCurrent:
        'Academy {0} is associated to {1}. They will be removed from current association. Proceed?'
    },
    label: 'Association',
    plural: 'Associations',
    responsibleAthleteCertificate: {
      label: 'Responsible In Athlete Certificate'
    }
  },
  associationUser: {
    create: {
      label: 'New User'
    },
    label: 'User',
    permissions: {
      academyRegistrationApproval: {
        abbr: 'Acad. Reg. Approval',
        label: 'Can approve academy registration requests'
      },
      championshipRegistrationRevision: {
        abbr: 'Champ. Reg. Edit.',
        label: 'Can edit student championship registration'
      }
    },
    plural: 'Users'
  },
  athlete: {
    label: 'Athlete',
    plural: 'Athletes'
  },
  athleteDocumentation: {
    plural: 'Documentations'
  },
  athleteActivity: {
    label: 'Athlete Activity',
    firstMembership: {
      label: 'First Membership as a Black Belt',
      help: 'Date, professor and academy of the first membership as a Black Belt.',
      emptyProfessor: 'No professor',
      emptyAcademy: 'No academy'
    },
    membership: {
      label: 'Memberships',
      help: 'Completed black belt membership requests.'
    },
    membershipApprovals: {
      label: 'Membership Approvals',
      help: `The years when there was at least one membership approved as professor.\n\nThe number on the right means the quantity of approvals.`
    },
    athleteCertificate: {
      label: 'Certificates',
      help: `The years when there was completed requests for athlete certificate.`
    },
    academyRegistrations: {
      label: 'Academy Registrations'
    },
    championshipRegistrations: {
      label: 'Championship Registrations'
    },
    activePeriod: {
      label: 'Active Period',
      years: '{0} years'
    },
    inactivePeriod: {
      label: 'Inactive Period'
    },
    summary: {
      label: 'Summary'
    },
    timelinePeriod: {
      active: 'Active',
      inactive: 'Inactive'
    },
    timelineYears: {
      degrees: {
        '-1': 'Past Activity',
        0: '0º degree',
        1: '1º degree',
        2: '2º degree',
        3: '3º degree',
        4: '4º degree',
        5: '5º degree',
        6: '6º degree',
        7: '7º degree',
        8: '8º degree',
        9: '9º degree'
      },
      sameYearDegreesTooltip: {
        message: 'Previous degrees granted in {0}:'
      }
    },
    eligibleDate: {
      label: 'New degree eligible from {0}.'
    },
    additionalActivity: {
      label: 'Additional Activities',
      removalTitle: 'Delete Additional Activity',
      removalText: 'Are you sure to delete this additional activity ?',
      empty: 'There is no additional activity.',
      created: 'Additional Activity created successfuly!',
      types: {
        blackBeltMembership: 'Black Belt Membership',
        academyRegistration: 'Academy Registration',
        athleteCertificate: 'Black Belt Certificate',
        additionalProfessor: 'Additional Professor',
        championshipRegistration: 'Championship Registration',
        membershipApproval: 'Membership Approval',
        rulesCourseCertificate: 'Rules Course Certificate',
        RTPCertificate: 'RTP Certificate',
        refereeing: 'Refereeing',
        others: 'Others'
      }
    },
    consideredYear: {
      activate: 'ON',
      activateTooltip: 'Consider this year as active.',
      desactivate: 'OFF',
      desactivateTooltip: 'Disregard this year as active.'
    },
    additionalActivityForm: {
      title: 'Add Additional Activity',
      type: {
        label: 'Activity type',
        options: {
          0: 'Black Belt Membership',
          1: 'Black Belt Certificate (Degree)',
          2: 'Academy Registration',
          3: 'Additional Professor',
          4: 'Championship Registration',
          5: 'Membership Approval',
          6: 'Rules Course Certificate',
          7: 'RTP Certificate',
          8: 'Refereeing',
          9: 'Other'
        },
        errors: {
          isNotEmpty: 'Activity type should not be empty.'
        }
      },
      activityAt: {
        label: 'Activity At',
        placeholder: 'Select the activity date',
        errors: {
          isNotEmpty: 'Activity at should not be empty.'
        }
      },
      description: {
        label: 'Description',
        errors: {
          isNotEmpty: 'Description should not be empty.'
        }
      },
      beltId: {
        label: 'Certificate Degree',
        errors: {
          degreeExistence: 'Athlete already has the degree.',
          degreeIsSmallerThanLast: 'Higher degree than the current one is not allowed.'
        }
      },
      document: {
        label: 'Document',
        dropInstructions: `
          Drop or click to upload<br />
          <strong>ACTIVITY DOCUMENT</strong>.
        `,
        uploadCompleted: 'Upload completed!'
      }
    },
    showActivities: 'Show athlete activities',
    error: 'An error occurred while processing the athlete activities.'
  },
  athleteCertificate: {
    label: 'Black Belt Certificate',
    plural: 'Certificates',
    view_all: 'View all certificates',
    new: 'Request Certificate',
    specialCase: 'Special Case',
    empty: "You don't have any certificates yet.",
    status: {
      0: 'Canceled',
      1: 'Pendent',
      2: 'Approved',
      canceled: 'Canceled',
      approved: 'Approved',
      pendent: 'Pendent'
    },
    cancel: {
      label: 'Cancel Certificate Request',
      text: 'Do you really want to cancel this request?'
    }
  },
  athleteGuardianship: {
    plural: 'Guardianships',
    guardian: {
      plural: 'Guardians'
    }
  },
  athleteMembership: {
    status: {
      active: 'Active',
      inactive: 'Inactive',
      never: 'No membership'
    },
    clear: {
      label: 'Clear Filters'
    },
    label: 'Athlete Membership',
    plural: 'Memberships',
    request: {
      label: 'Membership Request'
    },
    student: {
      label: 'Students Membership Request'
    },
    approvalPendent: {
      label: 'Pendents Approvals',
      approval: {
        success: 'Student membership successfully approved',
        danger: 'An error occurred while attempting approval.'
      },
      reject: {
        success: 'Student membership successfully rejected.',
        danger: 'An error occurred while attempting to reject.'
      }
    },
    expiresIn: 'Expires',
    expiredOn: 'Expired On',
    inactiveMessage:
      'Attention! In order to register and participate in championships and courses, your membership must be valid and must not expire before the day of the championship or course.'
  },
  athletePenalty: {
    plural: 'Penalties',
    infos: {
      title: 'Details',
      event: {
        label: 'Event',
        placeholder: 'Select the breach event'
      },
      infraction: {
        label: 'Infraction',
        placeholder: 'Describe the type of offense'
      },
      sentence: {
        label: 'Sentence',
        placeholder: 'Describe the penalty period'
      },
      level: {
        label: 'Level',
        placeholder: 'Select the offense level'
      },
      penaltyAt: {
        label: 'Occurred At',
        placeholder: 'Date of violation'
      },
      expireAt: {
        label: 'Expire At',
        placeholder: 'Infraction expiration date'
      },
      status: {
        label: 'Status'
      },
      revokedBy: {
        label: 'Revoked By'
      },
      revokedAt: {
        label: 'Revoked At'
      },
      note: {
        label: 'Notes',
        placeholder: 'Write a note about the infraction committed by the athlete'
      }
    },
    locks: {
      title: 'Types of Locks',
      membershipBlocked: {
        label: 'Block Membership Solicitation'
      },
      championshipBlocked: {
        label: 'Block Championship Subscription'
      },
      studentApprovalBlocked: {
        label: 'Block Student Approval'
      },
      diplomaBlocked: {
        label: 'Block Athlete Certificate'
      },
      rankingBlocked: {
        label: 'Block in Ranking'
      }
    },
    documents: {
      title: 'Documents',
      label: 'Attachment'
    },
    attached: {
      title: 'Attached Documents',
      label: 'Attached Documents'
    },
    status: {
      active: 'Active',
      expired: 'Expired',
      never: 'No Penalty'
    },
    membershipBlocked: {
      warning: {
        title: 'Attention!',
        body:
          'Due to an <b>active penalty</b>, card renewal is currently unavailable. Please wait until the penalty is lifted to proceed with renewals. If necessary, please contact us at <a href="mailto:ibjjf@ibjjf.com">ibjjf@ibjjf.com</a>.'
      },
      modal: {
        title: 'Active Penalty',
        body:
          '<p>Due to an <b>active penalty</b>, card renewal is currently unavailable. Please wait until the penalty is lifted to proceed with renewals.</p> <p>If necessary, please contact us at <a href="mailto:ibjjf@ibjjf.com">ibjjf@ibjjf.com</a>.</p',
        confirm: 'OK'
      }
    },
    athleteCertificateBlocked: {
      warning: {
        title: 'Attention!',
        body:
          'Due to an <b>active penalty</b>, the certificate request is currently unavailable. Please wait until the penalty is lifted to submit the request again. If necessary, please contact us at <a href="mailto:ibjjf@ibjjf.com">ibjjf@ibjjf.com</a>.'
      },
      modal: {
        title: 'Active Penalty',
        body:
          '<p>Due to an <b>active penalty</b>, the certificate request is currently unavailable. Please wait until the penalty is lifted to submit the request again.</p> <p>If necessary, please contact us at <a href="mailto:ibjjf@ibjjf.com">ibjjf@ibjjf.com</a>.</p>',
        confirm: 'OK'
      }
    },
    studentApprovalBlocked: {
      warning: {
        title: 'Attention!',
        body:
          'Due to an <b>active penalty</b>, the approval of memberships is currently unavailable. Please wait for the penalty to expire in order to proceed with the approvals. If necessary, please contact us at <a href="mailto:ibjjf@ibjjf.com">ibjjf@ibjjf.com</a>.'
      }
    }
  },
  auditLog: {
    notFound: 'No history found.'
  },
  authorizePaymentProfile: {
    label: 'Saved Card',
    new: 'New Credit Card',
    save: 'Save Credit Card Info'
  },
  belt: {
    blackList: 'Black Belts',
    label: 'Belt'
  },
  beltColor: {
    0: 'White',
    1: 'Grey',
    2: 'Yellow',
    3: 'Orange',
    4: 'Green',
    5: 'Blue',
    6: 'Purple',
    7: 'Brown',
    8: 'Black',
    9: 'Black First Degree',
    10: 'Red Tenth Degree',
    11: 'Black Second Degree',
    12: 'Black Third Degree',
    13: 'Black Fourth Degree',
    14: 'Black Fifth Degree',
    15: 'Black Sixth Degree',
    16: 'Red and Black Seventh Degree',
    17: 'Red and White Eighth Degree',
    18: 'Red Ninth Degree',

    // TODO: Check whether this legacy pattern is still being used somewhere.
    '8-1': 'Black First Degree',
    '8-10': 'Red Tenth Degree',
    '8-2': 'Black Second Degree',
    '8-3': 'Black Third Degree',
    '8-4': 'Black Fourth Degree',
    '8-5': 'Black Fifth Degree',
    '8-6': 'Black Sixth Degree',
    '9-7': 'Red and Black Seventh Degree',
    '9-8': 'Red and White Eighth Degree',
    '9-9': 'Red Ninth Degree',
    // TODO: Just to keep node compatibility, remove this when possible
    '8-7': 'Red and Black Seventh Degree',
    '8-8': 'Red and White Eighth Degree',
    '8-9': 'Red Ninth Degree'
  },
  beltColorInFull: {
    white: 'White',
    grey: 'Grey',
    yellow: 'Yellow',
    orange: 'Orange',
    green: 'Green',
    blue: 'Blue',
    purple: 'Purple',
    brown: 'Brown',
    black: 'Black',
    'black-1': 'Black First Degree',
    'black-2': 'Black Second Degree',
    'black-3': 'Black Third Degree',
    'black-4': 'Black Fourth Degree',
    'black-5': 'Black Fifth Degree',
    'black-6': 'Black Sixth Degree',
    'red-and-black': 'Red and Black Seventh Degree',
    'red-and-white': 'Red and White Eighth Degree',
    'red-9': 'Red Ninth Degree',
    'red-10': 'Red Tenth Degree'
  },
  boleto: {
    plural: 'Boletos'
  },
  certificates: {
    firstAid: { label: 'First Aid Course' },
    refereeingCourse: { label: 'Refereeing Course' },
    backgroundCheck: { label: 'Background Check' },
    safeSport: { label: 'SafeSport' },
    degreeNoteOrDenialReason: { label: 'Denial Reason or Note' },
    new: {
      title: 'New Certificate Request',
      subtitle: 'Submit the form below to proceed with the certificate request.'
    },
    form: {
      stepTitles: {
        start: 'Black Belt Membership',
        firstAidCourse: 'First Aid Course',
        refereeingCourse: 'Refereeing Course',
        backgroundCheck: 'Background Check',
        safeSport: 'SafeSport'
      },
      firstAidCourse: {
        dropInstructions: `
            Drop or click to upload your<br />
            <strong>FIRST AID COURSE CERTIFICATE</strong>.
          `
      },
      refereeingCourse: {
        dropInstructions: `
            Drop or click to upload your<br />
            <strong>REFEREEING COURSE CERTIFICATE</strong>.
          `
      },
      backgroundCheck: {
        backgroundCheckConfirmed: 'I have applied for a background check in the last 12 months.',
        notUSAResident: "I'm not USA resident",
        explanation: `
            <p>
              All USA residents must have a clean background check on file with NCSI within the last 12 months.
            </p>

            <p>
              Please refer to the
              <a
                href="https://ibjjf.com/background-check/"
                target="_blank"
                >Background Check</a
              >
              for more information.
            </p>
          `
      },
      safeSport: {
        safeSportConfirmed: 'I did the SafeSport course.',
        safeSportNotConfirmed: 'SafeSport not confirmed.',
        explanation: `
            <p>
              All USA residents must have completed the SafeSport Training Course within the last 12 months.
            </p>

            <p>
              Please refer to the <a href="https://ibjjf.com/safe-sport" target="_blank">SafeSport</a> for more information.
            </p>
          `
      },
      confirmationTitle: 'Your request was made!',
      confirmationSubtitle: "We'll check the provided information and contact you soon.",
      viewCertificates: 'View my certificates',
      continue: 'Continue'
    },
    degree: {
      label: 'Degree',
      placeholder: 'Select the degree',
      edit: 'Edit degree',
      cancelEdit: 'Cancel editing',
      hint:
        'Please note: Time for degrees will be evaluated based on the rules laid out in Article 4 of the <a href="https://ibjjf.com/info/graduation-system" target="_blank">IBJJF Graduation System</a>.',
      selectOptions: {
        denied: 'Denied',
        0: 'Black Belt (without degrees)',
        1: '1º degree',
        2: '2º degree',
        3: '3º degree',
        4: '4º degree',
        5: '5º degree',
        6: '6º degree',
        7: '7º degree',
        8: '8º degree',
        9: '9º degree'
      }
    },
    degreeTransition: {
      label: 'Degree transition',
      waitingApproval: 'Waiting approval',
      error: 'An error ocurred while fetching the information.'
    },
    signatures: {
      previewTitle: 'Signatures print preview',
      label: 'Signatures',
      center: 'center',
      left: 'left',
      right: 'right',
      useDefault: "Only the president's signature will appear on the certificate"
    },
    beltHistory: {
      title: 'Belt History',
      periodStartAt: 'Period start',
      periodEndAt: 'Period end',
      professor: 'Professor',
      academy: 'Academy'
    }
  },
  championship: {
    dashboard: {
      notFoundChampionship: 'No championship available.',
      notFoundSubscription: 'No tournament registration were found.',
      notFoundEditRegistrations:
        'No tournaments available for professor corrections were found at this time.'
    },
    upcomingChampionships: 'Upcoming Championships',
    emptyChampionships: 'There are no upcoming championships at this time.',
    registered: 'Registered',
    plural: 'Championships'
  },
  course: {
    upcomingCourses: 'Upcoming Courses',
    emptyCourses: 'There are no upcoming courses at this time.'
  },
  championshipBundle: {
    plural: 'Bundles'
  },
  championshipInvitation: {
    label: 'Championship Invitations'
  },
  championshipPrize: {
    label: 'Championship Prize',
    plural: 'Championship Prizes',
    edit: 'Edit Prizes'
  },
  championshipRegistration: {
    byDivision: {
      pdf: 'Inscriptions By Division in PDF',
      label: 'Edit By Division'
    },
    byTeam: {
      pdf: 'Inscriptions By Team in PDF',
      label: 'Edit By Team'
    },
    edit: {
      plural: 'Edit Inscriptions'
    },
    label: 'Championship Registration',
    plural: 'Inscriptions',
    professor: {
      changesDisabled: 'Inscriptions edition available between {0} and {1}'
    },
    search: {
      notFound: 'No registration found.'
    },
    students: 'Student Inscriptions',
    tooltips: {
      canceled: 'The period to edit your registration is now closed',
      changeAthlete: 'Edit your registration',
      changeProfessor: 'Edit team registration',
      paymentPendent: 'To edit your registration it is necessary for you to complete the payment',
      notRegistration: 'Registration for the championship is not available'
    },
    view: {
      plural: 'View Inscriptions'
    }
  },
  championshipRegistrationStatus: {
    completed: 'Registration Completed',
    paymentPendent: 'Payment Pendent',
    canceled: 'Registration Canceled'
  },
  emailQueue: {
    label: 'Emails Queue',
    plural: 'Emails Queue',
    dateQueue: {
      label: 'Dt. Queue'
    },
    dateDone: {
      label: 'Dt. Sent'
    }
  },
  emailSchedule: {
    plural: 'Schedules'
  },
  emailTemplate: {
    plural: 'Templates'
  },
  federation: {
    label: 'Federation',
    plural: 'Federations'
  },
  formFieldType: {
    association: {
      label: 'Association'
    },
    country: {
      label: 'Country'
    },
    file: {
      label: 'File'
    },
    email: {
      label: 'Email'
    },
    text: {
      label: 'Text'
    },
    title: {
      label: 'Title'
    }
  },
  gender: {
    label: 'Gender',
    male: 'Male',
    female: 'Female'
  },
  guardianship: {
    label: 'Parent or legal guardian',
    email: {
      label: 'Email Legal Guardian'
    },
    underAge: {
      label: 'Full name of minor'
    },
    athleteDateOfBirth: {
      label: "Minor's Date of Birth"
    },
    relationship: {
      label: 'Degree of Kinship',
      placeholder: 'Select the degree of kinship',
      father: {
        label: 'Father'
      },
      mother: {
        label: 'Mother'
      },
      legalGuardian: {
        label: 'Legal Guardian'
      },
      legal_guardian: {
        label: 'Legal Guardian'
      }
    },
    status: {
      all: 'All',
      approvalPendent: 'Pending Approval',
      rejected: 'Rejected',
      completed: 'Completed',
      documentRejected: 'Document Rejected',
      kinshipRejected: 'Kinship Rejected',
      initial: 'Initial',
      canceled: 'Canceled',
      expired: 'Expired'
    },
    approvalDate: 'Approval at',
    approvalBy: 'Approved by',
    approved: 'Approved',
    rejectedDate: 'Rejected at',
    rejectedBy: 'Rejected by',
    rejected: 'Rejected',
    close: 'Close',
    authorName: 'Approval by',
    staffNote: 'Note',
    criteria: {
      guardianIdentification: {
        title: 'Steps for document approval',
        readable: 'Document is readable',
        valid: 'Valid document as official photo ID',
        withinTheValidity: 'Document within the valid time frame',
        matchPhoto: 'Document with corresponding photo',
        matchNationality: 'Document with the same nationality',
        correctInfo: 'Document with the correct data'
      },
      underageAthleteIdentification: {
        title: 'Steps for document approval',
        readable: 'Document is readable',
        valid: 'Valid document as official photo ID',
        withinTheValidity: 'Document within the valid time frame',
        matchPhoto: 'Document with corresponding photo',
        matchNationality: 'Document with the same nationality',
        correctInfo: 'Document with the correct data'
      },
      legalBondIdentification: {
        readable: 'Document is readable',
        valid: 'Certificate issued by the competent authority',
        withinTheValidity: 'Document within the valid time frame',
        matchGuardianData: 'First and last names of the guardians are correct',
        matchMinorData: 'First and last names of the minor are correct',
        noErasure: 'Document does not contain erasures or amendments'
      }
    }
  },
  athleteDataChange: {
    title: 'Solicitation Data',
    beltHistory: 'Belt History',
    disapprovalReason: 'Reason for Disapproval',
    graduationDate: 'Graduation Date',
    canceledNotification: 'The athlete data change request was canceled.',
    changeType: {
      academyChange: 'Academy Change',
      beltChange: 'Belt Change',
      professorChange: 'Professor Change',
      academyProfessorChange: 'Academy and Professor Change',
      beltAcademyProfessorChange: 'Belt, Academy, and Professor Change',
      default: 'Data Change'
    },
    info: {
      academy: 'Academy',
      previousAcademy: 'Previous Academy',
      newAcademy: 'New Academy',
      belt: 'Belt',
      previousBelt: 'Previous Belt',
      claimedBelt: 'Solicitated Belt',
      professor: 'Professor',
      previousProfessor: 'Previous Professor',
      newProfessor: 'New Professor',
      isProfessor: 'Professor/Instructor',
      createdAt: 'Creation date'
    },
    status: {
      pendent: 'Guardian Approval',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      expired: 'Expired',
      canceled: 'Canceled'
    },
    errors: {
      onCancel:
        'An error has occurred while canceling the data change request, please try again later.'
    }
  },
  guardianApproval: {
    label: 'Pending Approval',
    approve: {
      label: 'approve'
    },
    reject: {
      label: 'reject'
    },
    createdAt: {
      label: 'Request Date'
    },
    approvableType: {
      label: 'Type'
    },
    approvalBy: {
      label: 'Approval by {0}'
    },
    professor: {
      label: 'Professor'
    },
    documentation: {
      label: 'Documentation',
      type: {
        photo: {
          label: 'Photo'
        },
        identification: {
          label: 'Identification document'
        },
        medicalWaiver: {
          label: 'Medical waiver'
        },
        proofOfAddress: {
          label: 'Proof of address'
        },
        physicalForm: {
          label: 'Physical form'
        }
      }
    },
    status: {
      pendent: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected'
    },
    membership: {
      isRenewal: {
        true: {
          label: 'Membership renewal'
        },
        false: {
          label: 'Membership registration'
        }
      }
    },
    athleteDataChange: {
      label: 'Athlete Data Change'
    },
    championshipRegistration: {
      championshipDate: { label: 'Championship Date' },
      championshipName: { label: 'Championship' },
      academyName: { label: 'Academy' },
      academyTeamName: { label: 'Time' },
      beltName: { label: 'Belt' },
      ageDivisionName: { label: 'Age Division' },
      federationAbbr: { label: 'Federation' },
      weightDivision: { label: 'Division by Weight' },
      tournamentDate: { label: 'Tournament Date' },
      registrationChangeByAthleteDateEnd: { label: 'Athlete Correction Deadline' }
    },
    championshipBundleRegistration: {
      championshipDate: { label: 'Championship Date' },
      championshipName: { label: 'Championship' },
      academyName: { label: 'Academy' },
      academyTeamName: { label: 'Time' },
      beltName: { label: 'Belt' },
      ageDivisionName: { label: 'Age Division' },
      federationAbbr: { label: 'Federation' },
      weightDivision: { label: 'Division by Weight' },
      tournamentDate: { label: 'Tournament Date' },
      registrationChangeByAthleteDateEnd: { label: 'Athlete Correction Deadline' }
    },
    sentToGuardians: 'Your solicitation was sent to your guardians.'
  },
  notification: {
    academyRegistration: {
      label: 'There was a problem loading academy registration data.'
    }
  },
  payment: {
    label: 'Payment',
    plural: 'Payments',
    authorizationText:
      'You must fill the payment info to continue your request. The payment will be collected once the academy registration has been approved.'
  },
  paymentProvider: {
    label: 'Payment Provider'
  },
  paymentType: {
    label: 'Payment Method',
    placeholder: 'Select the payment method',
    authorize: {
      label: 'Credit Card'
    },
    bankTransfer: {
      label: 'Bank Transfer'
    },
    boleto: {
      label: 'Boleto'
    },
    cash: {
      label: 'Cash'
    },
    paypal: {
      error: {
        message: 'An error has occurred. Try again later. If the problem persists, contact PayPal.'
      },
      go: 'Go to PayPal',
      label: 'PayPal',
      processing: {
        message: 'Processing payment'
      },
      linkTo: 'Link to PayPal'
    },
    pix: {
      label: 'PIX',
      create: 'Generate PIX'
    }
  },
  professorApprovals: {
    sentToProfessor:
      "Your profile update was sent to your professor. As soon as your professor approves it, you'll be notified.",
    rejections: {
      invalidBelt: {
        name: 'Invalid Belt',
        title: 'Invalid Belt',
        message: "You selected a belt you're not eligible for."
      },
      invalidBeltHistory: {
        name: 'Invalid Belt History',
        title: 'Invalid Belt History',
        message:
          'Your professor thinks that your belt history is incorrect. Please check the belts and graduation dates.'
      },
      wrongProfessor: {
        name: 'Invalid Professor',
        title: 'Invalid Professor',
        message: 'You selected a professor that is not your current professor.'
      },
      wrongAcademy: {
        name: 'Invalid Academy',
        title: 'Invalid Academy',
        message: 'You selected an academy that is not your current academy.'
      },
      invalidSolicitationData: {
        name: 'Invalid Solicitation Data',
        title: 'Invalid Solicitation Data',
        message: 'Your professor thinks that your solicitation data is incorrect. Please check.'
      }
    }
  },
  provisional: {
    academyUnavailable: `
      <b>The selected academy currently has no professor able to approve your request.</b><br />\
      According to article 7 on IBJJF Graduation Rules, registering for brown or black belt requires:<br />\
      <li>Brown Belt must be approved by a Black Belt professor with a minimum graduation of 2 (two) degrees.</li>\
      <li>Black Belt must be approved by a Black Belt professor with a minimum graduation of 3 (three) degrees.</li>`,
    previousProfessorUnableToApprove:
      '<p>The previously selected professor is unable to approve your request.</p><p>Please select another professor from the list.</p>',
    shouldSelectBeltBeforeProfessor: 'Please select a belt before choosing your professor.',
    athleteUpdate: {
      warning:
        '<b>You are on provisional period.</b> <br/> You can change your professor anytime but the provisional period will be reseted if you do so.',
      provisionalReset: `
        <b>Note that if you change professor, your provisional period will be reseted.</b> According to article 7 of IBJJF Graduation Rules,
        you must remain at least two years registered under the professor that first approved your membership.`
    },
    membershipRenewal: {
      warning:
        '<b>You are on provisional period.</b> <br/> You can change your professor anytime but the provisional period will be reseted if you do so.',
      provisionalReset: `
        <b>Note that if you change professor, your provisional period will be reseted.</b> According to article 7 of IBJJF Graduation Rules,
        you must remain at least two years registered under the professor that first approved your membership.`
    }
  },
  request: {
    dates: {
      academyActivationDt: {
        label: 'Academy Activation Dt.'
      },
      adminApprovalDt: {
        label: 'Admin Approval Dt.'
      },
      registryExpirationDt: {
        label: 'Registry Expiration Dt.'
      },
      requestDt: {
        label: 'Request Dt.'
      },
      printDt: {
        label: 'Print Dt.'
      },
      issuedDt: {
        label: 'Issue Dt.'
      },
      shippedDt: {
        label: 'Shipping Dt.'
      }
    },
    label: 'Request',
    shipping: {
      label: 'Shipping',
      inputLabel: 'Tracking code or URL',
      inputPlaceholder: 'e.g. AA123456789BR',
      markAsDelivered: 'Mark as delivered',
      unmarkAsDelivered: 'Unmark as delivered'
    },
    annotation: {
      label: 'Annotation'
    },
    messages: {
      updateSuccess: 'Request updated successfuly.',
      updateError: 'An error ocurred while updating the request, please try again.'
    }
  },
  status: {
    actionRequired: { label: 'Action is required' },
    initial: { label: 'Initial' },
    active: { label: 'Active' },
    all: { label: 'All' },
    approvalPendent: {
      label: 'Document Waiting for approval',
      notFound: { label: 'No pendent approval found' }
    },
    approved: {
      byUser: 'Approved by {0}',
      byFederation: 'Approved by {0}',
      label: 'Approved'
    },
    authorized: { label: 'Authorized' },
    AUTHORIZED: { label: 'Authorized' },
    bounce: { label: 'Not delivered' },
    canceled: { label: 'Canceled' },
    captured: { label: 'Captured' },
    complaint: { label: 'Spam' },
    completed: { label: 'Completed' },
    COMPLETED: { label: 'Completed' },
    confirmed: { label: 'Confirmed' },
    delivered: { label: 'Delivered' },
    documentPending: {
      label: 'Document Pending'
    },
    documentationPendent: {
      label: 'Documentation pending'
    },
    documentationWaitingApproval: {
      label: 'Documentation waiting approval'
    },
    done: { label: 'Done' },
    error: { label: 'Error' },
    expired: { label: 'Expired' },
    extinct: { label: 'Extinct' },
    failed: { label: 'Failed' },
    finished: { label: 'Finished' },
    formApprovalPendent: { label: 'Approval pendent' },
    inactive: { label: 'Inactive' },
    opened: { label: 'Opened' },
    paymentPendent: { label: 'Payment Pending' },
    paymentAuthorizationPendent: { label: 'Payment in analisys' },
    pendent: { label: 'Pendent' },
    pending: { label: 'Pending' },
    printPendent: { label: 'Pending print' },
    never: { label: 'Never' },
    noRegistry: {
      label: 'No Registry'
    },
    rejected: {
      label: 'Rejected',
      byUser: 'Rejected by {0}',
      byFederation: 'Rejected by {0}'
    },
    requested: { label: 'Requested' },
    running: { label: 'Running' },
    sent: { label: 'Sent' },
    submitted: { label: 'Submitted' },
    total: { label: 'Total' },
    waitingApproval: {
      byUser: 'Waiting approval by {0}',
      byFederation: 'Waiting approval by {0}',
      label: 'Waiting approval'
    },
    waitingResolving: { label: 'Pendent resolving' },
    free: { label: 'Free' },
    snoozed: { label: 'Snoozed' },
    pendentShippings: { label: 'Pendent Shippings' },
    filled: { label: 'Waiting to be sent' },
    payment: { label: 'Waiting Payment' },
    inAnalysis: { label: 'In analysis' },
    chargeBack: { label: 'Charged back' },
    processing: { label: 'Processing' }
  },
  user: {
    label: 'User',
    plural: 'Users'
  },
  weightDivision: {
    label: 'Weight Division',
    table: 'Weight Table',
    rooster: 'Rooster',
    lightFeather: 'Light Feather',
    feather: 'Feather',
    light: 'Light',
    middle: 'Middle',
    mediumHeavy: 'Medium Heavy',
    heavy: 'Heavy',
    superHeavy: 'Super Heavy',
    ultraHeavy: 'Ultra Heavy',
    openClass: 'OpenClass',
    openClassLight: 'OpenClass Light',
    openClassHeavy: 'OpenClass Heavy',
    0: 'Rooster',
    1: 'Light Feather',
    2: 'Feather',
    3: 'Light',
    4: 'Middle',
    5: 'Medium Heavy',
    6: 'Heavy',
    7: 'Super Heavy',
    8: 'Ultra Heavy',
    9: 'OpenClass',
    10: 'OpenClass Light',
    11: 'OpenClass Heavy'
  },
  championshipResults: {
    empty: 'There are no championship results at this time.',
    error:
      'An error has occurred while processing the championship results, please try again later.'
  },
  membership: {
    status: {
      initial: 'Initiated',
      documentPending: 'Pending Document',
      staffApproval: 'Doc. Awaiting Approval',
      professorApproval: 'Waiting Professor Approval',
      guardianApproval: 'Waiting Guardian Approval',
      payment: 'Waiting Payment',
      completed: 'Completed',
      print: 'Pending Printing',
      expired: 'Expired',
      canceled: 'Canceled'
    },
    canceledNotification: 'The membership request was canceled.',
    documents: {
      criteria: {
        title: 'Steps for document approval',
        subtitle:
          "<p>To approve a document, just change the switch status to <span class='has-text-success has-text-weight-bold is-uppercase'>approved</span>. If the criteria <span class='has-text-weight-bold is-uppercase'>don't</span> meet the necessary requirements, keep it marked as <span class='has-text-danger has-text-weight-bold is-uppercase'>rejected</span>.</p>",
        all: 'Approve all criteria above.',
        photo: {
          goodQuality: 'Photo with a centered and good quality face.',
          upToDate: 'Recent (within 6 months) and colored photo.',
          noAccessories: 'Photo without any accessory covering the face/head.',
          neutralFaceExpression: 'Photo with a neutral facial expression.',
          whiteBackground: 'Photo with a white background.',
          rejectionMessage:
            'Please upload a new photo looking directly at the camera with a neutral facial expression, following the standard/profile 3x4 format, in portrait orientation. The photo should have been taken within the last 6 months, be in color, taken in a well-lit environment, and be in front of a plain white background with your entire head and shoulders within the frame. Remember to remove glasses, hats, or any other accessory that covers your face/head.'
        },
        identification: {
          readable: 'Document is legible.',
          valid: 'Valid document with official photo identification.',
          withinTheValidity: 'Document is within the valid date range.',
          correctInfo: 'Document has correct information.',
          matchPhoto: 'Document has corresponding photo.',
          nationality: 'Document has the same nationality.',
          rejectionMessage:
            'Please make a new upload of an official identification document with a front and back photo (if applicable), with all readable data and within the valid date range (if applicable). Also, ensure that the information filled in the personal information step matches the details in the document submitted.'
        },
        medicalWaiver: {
          readable: 'Document is legible.',
          valid: 'Document is valid as a medical certificate.',
          upToDate: 'Recently issued (within 90 days).',
          doctorSignature: 'Signed by the doctor with a legible license number (CRM).',
          fitnessApproval: 'Confirms fitness for physical activities.',
          withDate: 'Includes date of issuance.',
          nationality: "Issued in the registered federation's country.",
          rejectionMessage:
            "Please upload a new medical certificate containing the registered athlete's name, issued in the registered federation's country, signed by a doctor with a legible license number (CRM), issued no more than 90 days ago, and indicating that the athlete is fit for physical activities. Medical certificates that impose any limitations on physical activities are not accepted. The athlete must be cleared to engage in sports at any intensity and manner. We do not accept certificates from Physical Educators, Physiotherapists, Psychologists, Dentists, etc."
        },
        physicalForm: {
          readable: 'Document is legible.',
          registrationForm: 'Document is valid as a registration form.',
          upToDate: 'Up-to-date registration form within the valid date range (180 days).',
          professorSignaturePresence: 'Signed by the indicated professor on the registration form.',
          professorSignatureValid: "Professor's signature is valid.",
          athleteSignature: 'Must be signed by the athlete',
          rejectionMessage:
            'Please upload a new registration form for your current request, signed by both the athlete and the professor listed on the form, dated within the last 6 months. Alternatively, you can request the listed professor on the registration form to approve the request online through their IBJJF profile on the page https://IBJJF.com IBJJF does not accept signatures made through Authentisign. Note: The professor\'s signature on the registration form must match our records. If one of the rejection reasons above is "The professor\'s signature is not valid," please ask the listed professor to sign the form again so that we can compare it to the signature we have on file, or request the listed professor to approve the request online as instructed above. The professor can also contact ibjjf@ibjjf.com to confirm their signature.'
        },
        proofOfAddress: {
          readable: 'Document is legible.',
          valid: 'Document is valid as proof of residence.',
          upToDate: 'Document is within the valid date range (90 days).',
          rejectionMessage:
            'Please upload a new document that proves your residence in the location provided in the address section of your registration form. We accept the following documents as proof of residence: bank statements, utility bills (electricity, gas, water), telephone bills, etc., with your name and address issued no more than 90 days ago.'
        }
      }
    }
  }
}
export const pages = {
  myInformation: {
    label: 'My Information'
  },
  login: {
    forgotEmail: 'Forgot your email?',
    forgot: 'Forgot your password?',
    backToEmail: 'Not you? Return',
    helpEmail:
      'If you have a valid membership id for this year and entered your e-mail correctly in the registration process, enter your e-mail and you will receive a password by e-mail',
    errorEmail: {
      label: 'Verification error',
      message: "We couldn't find your IBJJF Account"
    },
    successEmail: {
      label: 'Email successfully sent',
      message:
        "We've sent an email to {0} with a password reset link. Please Check your SPAM FOLDERS if you're not finding it."
    },
    label: 'Sign In',
    message: 'Please login to proceed',
    remember: 'Remember me',
    returnToLogin: {
      label: 'Return to Login'
    },
    sign: {
      button: 'Create a New Account'
    }
  },
  profile: {
    addressChangeSuccessMessage: 'Address updated'
  },
  passwordConfirmation: {
    error: 'Invalid or expired link',
    success: 'Password changed successfully'
  },
  passwordRule: {
    error:
      'Your password is in a invalid format. Please use only letters (lowercase or uppercase), numbers and symbols.',
    warning:
      "We've updated our system and some password formats are not allowed anymore. Use any account recovery method available to change your password."
  },
  athleteDashboard: {
    digitalCard: 'Digital Card',
    championshipCorrections: 'Championship Corrections',
    studentsMembership: 'Students Membership',
    associationConfirmation: 'Association Confirmation',
    additionalInstructor: 'Additional Instructor Confirmation',
    myAcademies: 'My Academies',
    documentation: 'Documentation',
    myChampionships: 'My Championships',
    myCourses: 'My Courses',
    blackBeltCertificates: 'Black Belt Certificates',
    myChampionshipResults: 'My Championship Results',
    myPersonalInfos: 'My Information',
    guardianApprovals: 'Supervised account approval requests',
    actionNeededWarning:
      '<strong>Attention!</strong><p class="mt-2 is-italic">During the registration process, some documents and/or information had errors and need to be corrected. Click on the button <strong>“CORRECT YOUR MEMBERSHIP DATA”</strong> to make the correction. </p>'
  },
  renewForm: {
    professorRequired: 'Please select a professor to continue with your membership renewal.',
    academyRequired: 'Please select an academy to continue with your membership renewal.'
  },
  guardianshipNewForm: {
    guardianSameAsMinor:
      "Cannot create guardianship for the same person, please log in with your legal guardian's account and try again.",
    userHasUnderAgeAthleteAssociated:
      "It is not possible to continue using the underage athlete account, please log in with your legal guardian's account and try again."
  },
  membershipCorrections: {
    addressChangeSuccessMessage:
      '<p class="has-text-weight-bold">Address saved successfully!</p><p class="mt-2 is-italic">Your address information has been saved successfully and you can change it whenever necessary.</p>',
    addressChangeErrorMessage:
      'An error occurred while submitting your address. Please try again later.'
  }
}
export const metrics = {
  currentYear: {
    label: 'Current Year'
  },
  lastYear: {
    label: 'Last Year'
  },
  referenceType: {
    label: 'Reference Type'
  },
  requestAvg: {
    label: 'Average Request Time'
  },
  requestByBeltColor: {
    label: 'Users by belt color'
  },
  requestCurrency: {
    label: 'Request Currency'
  },
  requestFederation: {
    label: 'Request Federation'
  },
  requestHistory: {
    label: 'Request History'
  },
  requestStatus: {
    label: 'Request Status'
  }
}

export const genericErrors = {
  network: "Can't connect to the server. Please, check your connection or try again later.",
  internalServer: 'An error has occurred, please try again later.'
}

// prettier-ignore
// ignoring "print width rule" in this case.
export const routeNames = {
  'athletes/digital-card': 'Digital Card',
  'athletes/profile': 'My Information',
  'athletes/championships': 'Championships',
  'athletes/courses': 'Courses',
  'athletes/professor-approvals': 'Students Membership',
  'athletes/academies/registrations': 'My Academies',
  'athletes/academies/registrations/': 'All',
  'athletes/academies/registrations/new': 'Registration',
  'athletes/academies/registrations/new/steps': 'Steps',
  'athletes/academies/registrations/new/academy-informations': 'Academy Informations',
  'athletes/academies/registrations/new/additional-professors': 'Additional Professors',
  'athletes/academies/registrations/new/association': 'Association',
  'athletes/academies/registrations/:academyRegistrationId': '{academyRegistration}',
  'athletes/academies/registrations/:academyRegistrationId/steps': 'Steps',
  'athletes/academies/registrations/:academyRegistrationId/academy-informations': 'Academy Informations',
  'athletes/academies/registrations/:academyRegistrationId/additional-professors': 'Additional Professors',
  'athletes/academies/registrations/:academyRegistrationId/association': 'Association',
  'athletes/academies/registrations/:academyRegistrationId/payment': 'Payment',
  'athletes/requests/approvals': 'Pendent Approvals',
  'athletes/certificates': 'Black Belt Certificates',
  'athletes/certificates/new': 'New Black Belt Certificate Request',
  'athletes/certificates/:id': 'Black Belt Certificate Request Summary',
  'athletes/certificates/:id/resume': 'Request Review',
  'athletes/certificates/:id/payment': 'Request Payment',
  'athletes/certificates/:id/confirmation': 'Request Payment Confirmation',
  'athletes/championships/corrections': 'Championship Corrections',
  'athletes/championships/invitations': 'Championship Invitations',
  'athletes/championships/registrations': 'Championship Registration',
  'athletes/championships/registrations/edit': 'Edit Championship Registration',
  'athletes/championships/results': 'My Championship Results',
  'athletes/guardianships/invite': 'Add Parent or legal guardian',
  'athletes/guardianships/invite/success': 'Add Parent or legal guardian',
  'athletes/requests/approvals/association': 'Association Confirmation',
  'athletes/requests/approvals/assistant-professor': 'Additional Instructor Confirmation',
  'athletes/championships/corrections/:championshipId': 'Edit Team Registrations',
  'athletes/requests/:requestId/payments/:paymentId?/authorized': 'Payment Authorization',
  'athletes/requests/:requestId/payments/:paymentId?/canceled': 'Payment',
  'athletes/documentation': 'Documentation',
  'athletes/memberships': 'My Membership',
  'athletes/memberships/my-membership': 'My Membership',
  'athletes/memberships/new': 'New Membership',
  'athletes/memberships/new/': 'Steps',
  'athletes/memberships/new/form': 'Steps',
  'athletes/memberships/new/form/personal-info': 'Personal Info',
  'athletes/memberships/new/form/address': 'Address',
  'athletes/memberships/new/form/athlete': 'Athlete Data',
  'athletes/memberships/new/form/statement': 'Statement',
  'athletes/memberships/new/form/confirmation': 'Confirmation',
  'athletes/memberships/update/': 'Membership',
  'athletes/memberships/update': 'Membership',
  'athletes/memberships/:id': 'Membership',
  'athletes/memberships/:id/': 'Steps',
  'athletes/memberships/:id/photo': 'Recent Photo',
  'athletes/memberships/:id/documents': 'Documents',
  'athletes/memberships/:id/documents/:type': '{documentType}',
  'athletes/memberships/:id/documents/:type/show': '{documentType}',
  'athletes/memberships/:id/documents/identification-type': 'Identification Document',
  'athletes/memberships/:id/payment': 'Payment',
  'athletes/memberships/:id/confirmation': 'Confirmation',
  'athletes/memberships/:id/form': 'Form',
  'athletes/memberships/:id/form/resend-athlete-data': 'Form',
  'athletes/memberships/renew': 'Renew Membership',
  'athletes/memberships/renew/form': 'Renew',
  'athletes/memberships/renew/statement': 'Statement',
  'athletes/memberships/renew/update-address': 'Update Address',
  'athletes/memberships/renew/update-shipping-address': 'Update Additional Delivery Address',
  'athletes/memberships/renew/update-athlete': 'Update Information',
  'athletes/memberships/corrections': 'My Membership',
  'athletes/memberships/corrections/': 'My Membership',
  'athletes/memberships/corrections/address': 'Residential Address',
  'athletes/profile/registration': 'My Registration',
  'athletes/profile/address': 'My Registration',
  'athletes/profile/athlete': 'My Registration',
  'athletes/updates': 'My Membership',
  'athletes/updates/:id': 'My Membership',
  'athletes/updates/:id/form': "My Membership",
  guardians: 'Home',
  'guardians/profile': 'My Information',
  'guardians/profile/address': 'My Information',
  'guardians/profile/address/new': 'Address',
  'guardians/profile/address/confirm': 'Address',
  'guardianships/guardian-approvals/': 'Guardian Approvals',
  'guardianships/guardian-approvals/:id': 'Guardian Approval',
  'guardianships/guardian-approvals/:id/documents/:type?': 'Guardian Approval',
  'guardianships/:id/documents': 'Documents',
  'guardianships/:id/documents/show': 'Documents',
  'guardianships/:id/documents/:type': '{documentType}',
  'guardianships/:id/documents/:type/show': '{documentType}',
  'guardianships/:id/documents/identification-type': 'Identification Document'

}
